/**
 * Permisos de gestión de templates (config.nRoles / config.roles).
 * Alineado con checkReadPermissions de Audit.vue e Issues.vue.
 */

/**
 * Compara ids de rol como string (pueden ser alfanuméricos/encriptados, no numéricos).
 */
const roleIdsMatch = (idA, idB) => {
    if (idA == null || idB == null) {
        return false
    }

    return String(idA) === String(idB)
}

/**
 * @param {object|null|undefined} config — template.config
 * @param {object|null|undefined} userRole — rol del usuario (employee/getRol)
 * @param {string|null|undefined} employeeRol — employee.rol (formato legacy en config.roles)
 * @returns {boolean}
 */
const hasTemplateViewPermission = (config, userRole, employeeRol) => {
    if (!userRole) {
        return false
    }

    if (Number(userRole.level) >= 8) {
        return true
    }

    if (!config || config === false || (!config.nRoles && !config.roles)) {
        return true
    }

    if (config.nRoles && config.nRoles.length > 0) {
        return config.nRoles.some((role) => {
            if (!roleIdsMatch(role.roleId, userRole.id) || !role.permissions) {
                return false
            }

            return role.permissions.includes('r') || role.permissions.includes('w')
        })
    }

    if (config.roles && config.roles.length > 0) {
        return config.roles.some((roleId) => roleIdsMatch(roleId, employeeRol))
    }

    return false
}

/**
 * @param {object} rootGetters
 * @returns {{ userRole: object, employeeRol: string }|null}
 */
const resolveCurrentUserRoleContext = (rootGetters) => {
    const employeeId = rootGetters['loginUser/getLocalEmployee']
    const employee = rootGetters['employee/getEmployee'](employeeId)

    if (!employee || employee.rol == null) {
        return null
    }

    const userRole = rootGetters['employee/getRol'](employee.rol) || null

    if (!userRole) {
        return null
    }

    return { userRole, employeeRol: employee.rol }
}

export { hasTemplateViewPermission, resolveCurrentUserRoleContext }
